import type {
  FormattedMission,
  MissionStatus
} from '@prizepicks/component-library/src/types/missions';
import { DateTime } from 'luxon';
import { isTimeBefore } from '@library/utils/dateTime';

export const formatMission = (challenge: FormattedMission) => {
  const {
    id,
    name,
    opt_in_by: optInBy,
    description,
    complete_by: completeBy,
    payout_type: payoutType,
    payout_amount_usd: payoutAmountUsd,
    promotion_id: promotionId,
    eligible_for_all: eligibleForAll
  } = challenge;

  const completeByDate = DateTime.fromISO(completeBy);
  const status: MissionStatus = isTimeBefore({
    dateValue: completeByDate
  })
    ? 'expired'
    : 'active';

  return {
    id,
    name,
    description,
    optInBy,
    completeBy,
    payoutType,
    payoutAmountUsd,
    promotionId,
    eligibleForAll,
    status
  };
};
